module.exports = __webpack_public_path__ + "img/icon-instagram.c6c14586.svg";